// React Dependencies
import React from 'react';

// External Dependencies
import { useHistory } from 'react-router-dom';

// Internal Dependencies
import RedirectBack from '../../common/RedirectBack';
import MasterNamesTable from './MasterNamesTable';

const MasterNames = () => {
  const history = useHistory();

  const onRedirectHandler = () => {
    if (history.length === 1) {
      window.close();
    } else {
      history.push('/admin/reviews');
    }
  };

  return (
    <div>
      <RedirectBack title="Manage Review Master Name" onRedirect={onRedirectHandler} />
      <MasterNamesTable />
    </div>
  );
};

export default MasterNames;
